export default "__VITE_ASSET__YiHoL1N3__"